import React from 'react';
import {
    InputV2,
    SelectV,
    ButtonLoading,
    SimpleDialog,
    Icons
} from 'components';

import {
    Grid,
    Button,
    Typography,

} from '@mui/material';
import { FormProvider } from 'react-hook-form';

const NewContactDg = (props) => {
    const { isNewDialogOpen,
        isSubmitting,
        setGrantUserDataType,
        handleCloseNew,
        grantUserDataType,
        grantTypeOptions,
        addContact,
        setFirstName,
        firstName,
        userContactInfo,
        lastName,
        setLastName,
        register,
        control,
        errors,
        methods,
        classes } = props;

    return (
        <SimpleDialog
            title={`تعریف مخاطب جدید`}
            open={isNewDialogOpen}
            icon={<Icons icon="userAdd" color="#303DBF" size="23" />}
            onClose={handleCloseNew}
            actions={
                <>
                    <ButtonLoading
                        name={'افزودن مخاطب'}
                        loading={isSubmitting}
                        variant="contained"
                        color="primary"
                        onClick={addContact}
                    />
                    <Button variant="contained" onClick={handleCloseNew}>
                        انصراف
                    </Button>
                </>
            }
        >
            <Typography className={classes.newItemHint}>
                مخاطبی با اطلاعات موردنظر در لیست مخاطبین <b>شعبه</b> شما وجود ندارد، ابتدا با تکمیل نام و نام خانوادگی، شخص مورد نظر را به مخاطبان <b>شعبه</b> خود اضافه کنید.
            </Typography>
            <FormProvider {...methods}>
                <form
                    className={classes.form}
                    autoComplete="off"
                >
                    <Grid container spacing={2} xs={12}>
                        <Grid item xs={12} md={6}>
                            <SelectV
                                name="type"
                                options={grantTypeOptions}
                                label="نوع اطلاعات مخاطب"
                                control={control}
                                register={register}
                                rules={['required']}
                                required
                                onChangeFunc={(k, e) => {
                                    setGrantUserDataType(e?.target?.value);
                                }}
                                defaultValue={grantUserDataType}
                                errors={errors}
                                disabled={true}
                                fullWidth
                                style={{
                                    backgroundColor: '#eeeeee',
                                    cursor: 'not-allowed',
                                    color: ' #757575',
                                    borderRadius: 8
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputV2
                                control={control}
                                register={register}
                                errors={errors}
                                name="contactNew"
                                label={grantTypeOptions.find((v) => v?.value === grantUserDataType)?.label}
                                mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                                fullWidth
                                dir="ltr"
                                placeholder=""
                                defaultValue={userContactInfo ?? ''}
                                disabled={true}
                                style={{
                                    backgroundColor: '#eeeeee',
                                    cursor: 'not-allowed',
                                    color: ' #757575',
                                    borderRadius: 8
                                }}

                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputV2
                                control={control}
                                register={register}
                                errors={errors}
                                name="firstNameNew"
                                label="نام"
                                defaultValue={firstName}
                                mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                                fullWidth
                                onChangeValue={(e) => setFirstName(e?.target?.value)}
                                placeholder=""
                                rules={['required']}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputV2
                                label="نام خانوادگی"
                                errors={errors}
                                name="lastNameNew"
                                control={control}
                                register={register}
                                defaultValue={lastName}
                                onChangeValue={(e) => setLastName(e?.target?.value)}
                                mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                                fullWidth
                                placeholder=""
                                rules={['required']}
                            />
                        </Grid>
                    </Grid>
                </form>
            </FormProvider>
        </SimpleDialog>

    )
}

export default NewContactDg;